export const certificates = {
  title: 'Giấy chứng nhận',
  resourceName: 'Giấy chứng nhận',
  titles: {
    list: 'Danh sách giấy chứng nhận',
    detail: 'Chi tiết giấy chứng nhận',
    create: 'Thêm giấy chứng nhận',
    edit: 'Sửa giấy chứng nhận',
    addQuick: 'Thêm nhanh',
  },
  sections: {
    basic: 'Thông tin cơ bản',
    linkage: 'Thông tin liên kết doanh nghiệp',
    validity: 'Hiệu lực và trạng thái',
    note: 'Ghi chú',
    audit: 'Ghi chú và thông tin hệ thống',
  },
  units: {
    days: 'ngày',
  },
  fields: {
    code: 'Mã giấy chứng nhận',
    name: 'Tên giấy chứng nhận',
    certificateType: 'Loại giấy chứng nhận',
    licenseNumber: 'Số giấy phép',
    expiryDate: 'Ngày hết hạn',
    warningDays: 'Thời gian cảnh báo',
    createdAt: 'Ngày tạo',
    updatedAt: 'Ngày cập nhật',
    status: 'Trạng thái',
    onOffAction: 'Bật / Tắt',
    certificateName: 'Tên chứng nhận',
    productCode: 'Mã sản phẩm liên kết',
    registeredCompany: 'Công ty đăng ký GCN',
    exporterCompany: 'Công ty xuất khẩu',
    importerCompany: 'Công ty nhập khẩu',
    effectiveDate: 'Ngày áp dụng',
    issueDate: 'Ngày phát hành',
    daysToExpire: 'Thời gian đến khi hết hạn',
    warningBeforeExpiry: 'Cảnh báo trước 60 ngày',
    note: 'Ghi chú',
    actions: 'Hành động',
  },
  filter: {
    country: 'Phân loại công ty',
    allCountries: 'Tất cả',
  },
  countries: {
    VN: 'Việt Nam',
    TQ: 'Trung Quốc',
  },
  status: {
    active: 'Đang hoạt động',
    inactive: 'Ngừng hoạt động',
    enabled: 'Bật',
    disabled: 'Tắt',
  },
  validation: {
    nameRequired: 'Vui lòng nhập tên chứng nhận',
    companyRequired: 'Vui lòng chọn đủ 3 công ty',
  },
  messages: {
    importDescription: 'Chọn file Excel đúng mẫu để nhập giấy chứng nhận.',
    importSuccess: 'Import giấy chứng nhận thành công',
    importFailed: 'Import giấy chứng nhận thất bại',
    exportSuccess: 'Xuất dữ liệu thành công',
    exportFailed: 'Xuất dữ liệu thất bại',
    noData: 'Không có dữ liệu giấy chứng nhận',
    totalCertificates: 'Tổng: {total} giấy chứng nhận',
    createSuccess: 'Tạo giấy chứng nhận thành công',
    updateSuccess: 'Cập nhật giấy chứng nhận thành công',
    deleteSuccess: 'Xóa giấy chứng nhận thành công',
    confirmDelete: 'Bạn có chắc muốn xóa giấy chứng nhận này?',
  },
  import: {
    button: 'Import',
    noSheet: 'File import không có sheet dữ liệu',
    noData: 'Không có dữ liệu để import',
    success: 'Import thành công {count} dòng',
    failed: 'Import thất bại',
  },
}
